import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@mui/material'
import { IconSave } from 'assets/images'
import { t } from 'i18n'
import React, { useEffect, useState } from 'react'
import { AssumedInjuryV2 } from 'store/ducks/report/types'
import { InjuryForm } from './InjuryForm'

interface InjuryModalProps {
  open: boolean
  mode: 'add' | 'edit'
  initialInjury?: AssumedInjuryV2
  onClose: () => void
  onSave: (injury: AssumedInjuryV2) => void
}

const createEmptyInjury = (): AssumedInjuryV2 => ({
  injuredBodyPart: undefined,
  assumedInjury: undefined,
  side: undefined,
  orientation: undefined,
  comments: ''
})

export const InjuryModal: React.FC<InjuryModalProps> = ({
  open,
  mode,
  initialInjury,
  onClose,
  onSave
}) => {
  const [injury, setInjury] = useState<AssumedInjuryV2>(createEmptyInjury())

  // Initialize form data based on mode and props
  useEffect(() => {
    if (open) {
      if (mode === 'edit' && initialInjury) {
        setInjury({ ...initialInjury })
      } else {
        setInjury(createEmptyInjury())
      }
    }
  }, [open, mode, initialInjury])

  const handleSave = () => {
    onSave(injury)
    onClose()
  }

  const isEdit = mode === 'edit'
  const isCondition =
    injury.assumedInjury === 'dead' || injury.assumedInjury === 'acuteSickness'
  const canSave =
    (injury.assumedInjury && injury.injuredBodyPart) || isCondition

  const title = t(isEdit ? 'edit' : 'addInjury')
  const saveButtonLabel = t(isEdit ? 'saveInformation' : 'addInjury')

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <InjuryForm
          injury={injury}
          onChange={setInjury}
          namePrefix={isEdit ? 'edit' : 'new'}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('cancel')}</Button>
        <Button
          onClick={handleSave}
          variant="contained"
          disabled={!canSave}
          startIcon={<IconSave />}
        >
          {saveButtonLabel}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default InjuryModal
